/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CalendarIcon16Light } from './CalendarIcon16Light';
import { CalendarIcon16Regular } from './CalendarIcon16Regular';
import { CalendarIcon16Solid } from './CalendarIcon16Solid';
import { CalendarIcon20Light } from './CalendarIcon20Light';
import { CalendarIcon20Regular } from './CalendarIcon20Regular';
import { CalendarIcon20Solid } from './CalendarIcon20Solid';
import { CalendarIcon24Regular } from './CalendarIcon24Regular';
import { CalendarIcon24Solid } from './CalendarIcon24Solid';
import { CalendarIcon32Regular } from './CalendarIcon32Regular';
import { CalendarIcon64Regular } from './CalendarIcon64Regular';
var sizes = {
    16: {
        light: CalendarIcon16Light,
        regular: CalendarIcon16Regular,
        solid: CalendarIcon16Solid,
    },
    20: {
        light: CalendarIcon20Light,
        regular: CalendarIcon20Regular,
        solid: CalendarIcon20Solid,
    },
    24: {
        regular: CalendarIcon24Regular,
        solid: CalendarIcon24Solid,
    },
    32: {
        regular: CalendarIcon32Regular,
    },
    64: {
        regular: CalendarIcon64Regular,
    },
};
export var CalendarIcon = forwardRef('CalendarIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
